import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import { Link } from 'gatsby'
import cx from 'classnames'

import LinkButton from 'components/LinkButton'
import { CONTACT_ROUTE } from 'routes/constants'
import { SectionData } from './constants'

const FeaturedProjects = ({
  projects,
  buttonText,
  hasFooterButtonMobile,
  hasNoPaddingBottom,
}) => (
  <div
    className={cx('sem__featured-projects', {
      '--has-no-padding-bottom': hasNoPaddingBottom,
    })}
  >
    {map(projects, (project, index) => (
      <div
        className={cx('featured-projects__project', `--${project.key}`)}
        key={`seo-project-${index}`}
      >
        <Link to={project.route} className="featured-projects__project-link">
          <div className="featured-projects__container">
            <div className="featured-projects__project-content">
              {project.logo && (
                <div className="featured-projects__project-logo">
                  <project.logo />
                </div>
              )}
              <p className="featured-projects__project-description">
                {project.description}
              </p>
            </div>
            {project.image && (
              <div className="featured-projects__project-image">
                <img src={project.image} alt={project.title} loading="lazy" />
              </div>
            )}
          </div>
        </Link>
      </div>
    ))}
    {hasFooterButtonMobile && (
      <LinkButton text={buttonText} route={CONTACT_ROUTE} />
    )}
  </div>
)

FeaturedProjects.defaultProps = SectionData

FeaturedProjects.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.object),
  buttonText: PropTypes.string,
  hasFooterButtonMobile: PropTypes.bool,
  hasNoPaddingBottom: PropTypes.bool,
}

export default FeaturedProjects
